module.exports = __webpack_public_path__ + "static/agency-banner-2d3e4917c1371847a8c974363dc4f88e.png";